<img [src]="StorageURL + data?.footer?.payment_option_image_url" alt="payment options">